import axios from 'axios';

export default axios.create({
  baseURL: 'https://apitreinamentos.cieemg.org.br',
});
